import React from 'react';
import { createForm } from 'rc-form'
import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

import google_favicon from 'static/images/icons/google-favicon-vector@3x.png'
import fb_favicon from 'static/images/icons/facebook@3x.png'

const VerifyDialog = props => {
    const { t } = useTranslation();
    const handleOnSubmit = type => {
        if (type === 'email') {
            props.form.validateFields((error, value) => {
                if (!error) {
                    props.onSubmit(type, value)
                }
            })
        } else {
            props.onSubmit(type, {})
        }
    }

    const { form, open, onClose, action, onActionChange } = props
    const { getFieldProps, getFieldError } = form
    const emailErr = getFieldError('email')
    const pwdErr = getFieldError('password')

    return (
        <Dialog className="dialog" open={open} onClose={onClose}>
            <DialogTitle className="dialog-title">
                <CloseIcon className="dialog-close" onClick={onClose} />
            </DialogTitle>
            <DialogContent style={{ padding: '0 32px 12px' }}>
                <Button
                    size="small"
                    style={{ width: '100%', border: 'solid 2px #4568b2', backgroundColor: '#4568b2', color: 'white', marginBottom: '16px', padding: '10px 0' }}
                    onClick={() => handleOnSubmit('facebook')}
                >
                    <img src={fb_favicon} style={{ width: '11px', marginRight: '47px' }} alt="facebook" />
                    <Typography color="inherit">使用 Facebook 帳號繼續</Typography>
                </Button>
                <Button
                    size="small"
                    style={{ width: '100%', border: 'solid 2px rgba(74, 79, 85, 0.1)', backgroundColor: 'white', color: '#9fa2a3', padding: '10px 0' }}
                    onClick={() => handleOnSubmit('google')}
                >
                    <img src={google_favicon} style={{ width: '19px', marginRight: '47px' }} alt="google" />
                    <Typography color="inherit">使用 Google 帳號繼續</Typography>
                </Button>
                <div className="d-flex align-items-center" style={{ margin: '28px 0 12px 0' }}>
                    <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
                    <span style={{ color: '#9fa2a3', margin: '0 24px' }}><Typography color="inherit">或</Typography></span>
                    <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
                </div>
                <TextField
                    name="email"
                    id="email"
                    size="small"
                    variant="outlined"
                    placeholder="電子郵件"
                    inputProps={{
                        ...getFieldProps('email', {
                            initialValue: '',
                            rules: [{
                                type: 'email',
                                required: true
                            }]
                        })
                    }}
                    margin="normal"
                    style={{ width: '100%' }}
                    error={emailErr && emailErr !== null}
                    helperText={emailErr || ''}
                    FormHelperTextProps={{
                        error: emailErr && emailErr !== null
                    }}
                />
                <TextField
                    name="password"
                    id="password"
                    type="password"
                    size="small"
                    variant="outlined"
                    placeholder="密碼"
                    inputProps={{
                        ...getFieldProps('password', {
                            initialValue: '',
                            rules: [{
                                required: true
                            }]
                        })
                    }}
                    margin="normal"
                    style={{ width: '100%' }}
                    error={pwdErr && pwdErr !== null}
                    helperText={pwdErr || ''}
                    FormHelperTextProps={{
                        error: pwdErr && pwdErr !== null
                    }}
                />
            </DialogContent>
            <DialogActions className="dialog-func">
                {action === 'register' &&
                    <Grid container justify="center" alignItems="center">
                        <Typography className="typography">
                            已有帳號？<span onClick={() => onActionChange('login')}>{t('login')}</span>
                        </Typography>
                    </Grid>
                }
                <Grid container justify="space-between" alignItems="center" style={{ marginTop: '20px' }}>
                    {action === 'login' &&
                        <Typography className="typography">
                            <span onClick={() => onActionChange('forgetpassword')}>忘記密碼</span>
                            <span onClick={() => onActionChange('register')}>{t('register')}</span>
                        </Typography>
                    }
                    {action === 'register' &&
                        <Typography className="typography">
                            一但您註冊本服務，即代表您已了解並接受
                            <Link target="_blank" color="primary" href="/terms-of-use">CellWine服務條款</Link>
                        </Typography>
                    }
                    <Button color="primary" variant="contained" onClick={() => handleOnSubmit('email')}>
                        {action === 'login' ? t('login') : t('register')}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default createForm()(VerifyDialog)